import EventsSubscriptionsController from 'controllers/Settings/RulesEditorController/EventsSubscriptionsController'

import styles from './UserController.module.sass'

const UserEventsSubscriptionController = () => {
	return (
		<div className={styles['subscriptions-editor-container']}>
			<EventsSubscriptionsController
				ruleType='events-subscriptions'
				taskType='user-notifications'
			/>
		</div>
	)
}

export default UserEventsSubscriptionController
